var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input" }, [
    _c("label", {
      staticClass: "label-hidden",
      attrs: { for: "CreatePassword" },
      domProps: { innerHTML: _vm._s(_vm.label) }
    }),
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.password,
          expression: "password"
        }
      ],
      staticClass: "customer-register-input",
      attrs: {
        required: "",
        type: "password",
        name: "customer[password]",
        id: "CreatePassword",
        autocomplete: "off",
        placeholder: _vm.placeholder
      },
      domProps: { value: _vm.password },
      on: {
        focus: function($event) {
          _vm.message = true
        },
        blur: function($event) {
          _vm.message = false
        },
        input: [
          function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.password = $event.target.value
          },
          _vm.disableBtn
        ]
      }
    }),
    _vm.message
      ? _c(
          "div",
          { staticClass: "message" },
          [
            _vm.password.length > 4
              ? _c("icon", {
                  attrs: {
                    name: "checkmark_small",
                    size: "12px",
                    color: "#058019"
                  }
                })
              : _c("icon", { attrs: { name: "close-red", size: "12px" } }),
            _c(
              "span",
              {
                staticClass: "message__text",
                style: { color: _vm.messageColor }
              },
              [_vm._v("Be at least 5 characters")]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }